export default __webpack_public_path__ + "form-section.png";